import React from "react"

import style from "./index.module.css";

export default class QuoteList extends React.Component {
  render() {
    var quotes = this.props.quotes;
    return (
      <div className={style.list}>
        {quotes.map(({ quote, source }, index) => {
          return (
            <div key={index} className={style.container}>
              <div className={style.quote}>{quote.quote}</div>
              <div className={style.source}>{source}</div>
            </div>
          )
        })}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/QuoteList/index.js